<template>
  <div class="conversation-page">
    <!-- <Nav @click-left="onClickLeft">
      <template #title>
        <div class="title-box">
          <img :src="state.imapi+'/api/v1/'+state.channelInfo?.logo+'?v='+Date.now()" />
          <h3 class="van-ellipsis">{{state.channelInfo?.title}}</h3>
        </div>
      </template>
<template #right>
        <van-icon name="ellipsis" color="#12CDB0" size="24px" @click="onOpen" />
      </template>
</Nav> -->


    <van-sticky>
      <van-nav-bar safe-area-inset-top fixed :border="false">
        <template #title>
          <p>{{ state.channelInfo?.title }}</p>
        </template>
        <!-- <template #left>
          <div class="left-nr" @click="$router.back()">
            <img src="../../../assets/nav/yz_nav_fh.png" alt="" />
          </div>
        </template> -->
        <!-- <template #right>
          <van-icon name="ellipsis" color="#12CDB0" size="24px" @click="onOpen" />
        </template> -->
      </van-nav-bar>
    </van-sticky>

    <div style="display: flex;flex-direction: column;height: 100%;">
      <div style="flex: 1;overflow: hidden;">
        <List v-if="store.state.imtoken && state.isLoadEnd" :subscribers="state.subscribers"></List>
      </div>
      <div v-if="state.isJoinGroup" class="foot">
        <div v-if="state.currentReplyMessage" class="reply-box">
          <div class="close" @click="state.currentReplyMessage = null">
            <van-icon name="cross" size="20" />
          </div>
          <div class="info">
            <div class="user">
              <van-image :src="state.currentReplyMessage?.user_extra?.avatar" round class="user-avatar"></van-image>
              <h3>{{ state.currentReplyMessage?.user_extra?.nickname || '匿名' }}</h3>
            </div>
            <p>{{ state.currentReplyMessage?.content?.conversationDigest }}</p>
          </div>
        </div>
        <div style="height: 10px;"></div>
        <div class="textarea-box" ref="textareaRef">
          <!-- <div class="foot-gn">
            <van-uploader :max-count="1" :after-read="afterRead">
              <img src="@/assets/chat/chat_input_image.png" />
            </van-uploader>
          </div> -->
          <!-- 输入框 -->
          <textarea v-model="state.inputValue" @input="handleInput" @click="handleInputClick" ref="inputRef"
            class="at-input" placeholder="说点什么吧..." @keyup.enter="onEnter" @keydown.enter="onKeydown"
            @compositionstart="state.isComposing = true" @compositionend="state.isComposing = false"></textarea>
          <div class="btn" @click="onFs">发送</div>

          <!-- @用户列表弹窗 -->
          <div v-if="state.showUserList" class="user-list" :style="{ bottom: `${listTop}`, left: `${listLeft}` }">
            <div v-for="user in state.selectedItems" :key="user.id" class="user-item" @click="selectUser(user)">
              <van-image :src="user.icon" round class="user-avatar"></van-image>
              <p class="name">{{ user.display }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="inputTopV" ref="fieldRef" v-else>
        <div @click="applyTeam()">
          <span>快发表一条言论吧～</span>
          <span>加入群聊</span>
        </div>
      </div>

    </div>





    <!-- 聊天信息 -->
    <Popup ref="conversationPopup" :subscribers="state.subscribers" :channelInfo="state.channelInfo"></Popup>
  </div>
</template>
<script>
import {
  reactive,
  onMounted,
  ref,
  onUnmounted,
  nextTick,
  provide
} from 'vue'
import {
  useRoute,
  useRouter
} from 'vue-router'
import {
  Toast
} from 'vant'
import {
  useStore
} from "vuex"
import WKSDK from "wukongimjssdk"
import {
  // ConnectStatus,
  ChannelTypeGroup,
  ChannelTypePerson,
  Channel,
  MessageText,
  MessageImage,
  Reply,
  Mention
} from "wukongimjssdk";
import List from "./list.vue"
import Popup from "./popup.vue"
import axios from 'axios'
import imrequest from '@/utils/imrequest.js'
import { getQueryString } from '../../../utils/location'
import { initDataSource } from '../../../services/datasource'
import { groupsMembers, isJoinGroup, userLogin } from '../../../api/im'
import { getConversations, initIm } from '../../../utils/imtools'
import md5 from 'js-md5'
import { wkGroupBlacklist } from '../../../api/gameindex'

class MentionModel {
  constructor() {
    // 对应 TS 中的 all: boolean = false
    this.all = false;
    // 对应 TS 中的 uids?: Array<string>（可选属性，初始化为 undefined）
    this.uids = undefined;
  }
}

export default {
  name: 'wukongimconversation',
  components: {
    List,
    Popup
  },
  setup() {
    const store = useStore()
    const route = useRoute()
    const router = useRouter()
    // 输入框DOM引用
    const inputRef = ref(null)
    // 容器DOM引用
    const textareaRef = ref(null)
    // 聊天信息弹窗
    const conversationPopup = ref(null)
    const state = reactive({
      imapi: process.env.VUE_APP_BASE_IM_API,
      // 频道id
      channelID: "",
      // 频道类型
      channelType: ChannelTypeGroup,
      // 频道信息
      channelInfo: null,
      // 输入框
      inputValue: '',
      // 是否显示用户列表
      showUserList: false,
      // 订阅者
      subscribers: null,
      // 输入
      isComposing: false,
      hasHandled: false,
      // 要回复的对象
      grandsonValue: null,
      // @用户数据
      selectedItems: [],
      // @选中信息
      mentionCache: {},
      // 要回复的信息
      currentReplyMessage: null,

      isJoinGroup: false,
      isLoadEnd: false
    })

    // 返回
    const onClickLeft = () => {
      router.back()
    }
    // 用户列表位置
    const listTop = ref(0)
    const listLeft = ref(0)
    // 记录@符号的位置
    const atPosition = ref(-1)
    // 处理输入事件
    const handleInput = () => {
      const input = state.inputValue

      // if (!input) {
      //   state.showUserList = false
      //   return
      // }
      // 获取当前光标位置
      const cursorPos = inputRef.value.selectionStart
      // 获取最后一个@的位置
      const lastAtIndex = input.lastIndexOf('@')

      // 关键判断：光标在@的下一位，且@后面无其他内容
      const isCursorAfterAt = cursorPos === lastAtIndex + 1
      const afterAtContent = input.substring(lastAtIndex + 1)
      const isAfterAtEmpty = afterAtContent.trim() === ''

      if (lastAtIndex !== -1 && isCursorAfterAt && isAfterAtEmpty) {
        atPosition.value = lastAtIndex
        calculateListPosition()
        state.showUserList = true
      } else {
        state.showUserList = false
      }
    }

    // 处理输入框点击事件（重新计算列表位置）
    const handleInputClick = () => {
      // if (state.showUserList) {
      //   calculateListPosition()
      // }
      handleInput()
    }

    // 计算用户列表的显示位置
    const calculateListPosition = () => {
      if (!inputRef.value) return

      const inputRect = inputRef.value.getBoundingClientRect()
      // const containerRect = textareaRef.value.getBoundingClientRect()

      // 获取光标位置
      // const cursorPosition = inputRef.value.selectionStart
      // 创建临时元素计算光标位置的偏移
      const tempElement = document.createElement('span')
      tempElement.style.visibility = 'hidden'
      tempElement.style.position = 'absolute'
      tempElement.textContent = state.inputValue.substring(0, atPosition.value + 1)
      document.body.appendChild(tempElement)

      // 计算列表位置
      listLeft.value = tempElement.offsetWidth + 10
      listTop.value = inputRect.height + 5

      document.body.removeChild(tempElement)
    }

    // 选择用户
    const selectUser = (user) => {
      if (atPosition.value === -1) return

      // 拼接新的输入内容：@之前的内容 + @用户名 + 空格
      const beforeAt = state.inputValue.substring(0, atPosition.value)
      const newContent = `${beforeAt}@${user.display} `

      state.inputValue = newContent
      state.showUserList = false

      // console.log(user)
      state.mentionCache[user.display] = {
        uid: user.id,
        name: user.display
      }
      // console.log(state.mentionCache)

      // 聚焦输入框并设置光标位置
      nextTick(() => {
        if (inputRef.value) {
          inputRef.value.focus()
          inputRef.value.selectionStart = newContent.length
          inputRef.value.selectionEnd = newContent.length
        }
      })
    }

    // 点击外部关闭用户列表
    const handleClickOutside = (e) => {
      if (
        textareaRef.value &&
        !textareaRef.value.contains(e.target) &&
        state.showUserList
      ) {
        state.showUserList = false
      }
    }
    // 加载频道信息完成
    const loadChannelInfoFinished = () => {
      console.log("loadChannelInfoFinished22")
      console.log("loadChannelInfoFinished11",state.channelType)
      if (state.channelType != ChannelTypeGroup) {
        return
      }

      console.log("subscribers11",WKSDK.shared().channelManager.getSubscribes(new Channel(state.channelID, state
        .channelType)))
      // 获取订阅者
      state.subscribers = WKSDK.shared().channelManager.getSubscribes(new Channel(state.channelID, state
        .channelType))

        console.log('获取订阅者', state.subscribers)
      if (state.subscribers.length > 0) {
        getMembers()
      } else {
        // 同步订阅者
        WKSDK.shared().channelManager.syncSubscribes(new Channel(state.channelID, state.channelType)).then(() => {
          state.subscribers = WKSDK.shared().channelManager.getSubscribes(new Channel(state.channelID, state
            .channelType))
          console.log('获取订阅者', state.subscribers)
          getMembers()
        })
      }
      state.isLoadEnd = true
    }
    // 获取频道信息
    const getPdData = () => {
      console.log("getPdData1",state.channelID,state.channelType)
      console.log("channelInfo132",WKSDK.shared().channelManager.getChannelInfo(new Channel(state.channelID,
        state.channelType)))
      state.channelInfo = WKSDK.shared().channelManager.getChannelInfo(new Channel(state.channelID,
        state.channelType))

      if (!state.channelInfo) {
        WKSDK.shared().channelManager.fetchChannelInfo(new Channel(state.channelID, state.channelType)).then(() => {
          state.channelInfo = WKSDK.shared().channelManager.getChannelInfo(new Channel(state.channelID,
            state.channelType))
          // 同步频道订阅者
          loadChannelInfoFinished()
        })
      } else {
        // 同步频道订阅者
        loadChannelInfoFinished()
      }
    }

    // 获取图片宽高
    const getImageDimensions = (imageUrl) => {
      return new Promise((resolve) => {
        let img = new Image()
        img.src = imageUrl
        img.onload = function () {
          const imgData = {
            width: img.width,
            height: img.height,
          }
          resolve(imgData)
        }
      })
    }

    const onEnter = () => {
      // 中文输入法正在组合输入时，不触发
      if (state.hasHandled || state.isComposing.value) return
      // onFs()
    }

    const onKeydown = () => {
      if (!state.isComposing) {
        state.hasHandled = false
        return
      }
      // 中文输入法状态下回车确认输入
      state.hasHandled = true
    }
    // 获取@用户列表
    const getMembers = () => {
      let members = state.subscribers.filter((s) => s.uid != store.state.imuid)
      if (members && members.length > 0) {
        state.selectedItems = members.map((member) => {
          const item = {}
          item.id = member.uid
          item.icon = member.avatar
          item.display = member.remark || member.nickname || member.name
          return item
        });
        state.selectedItems.splice(0, 0, {
          icon: require('@/assets/touxiang.png'),
          id: -1,
          display: '所有人'
        });
      }

    }

    const formatMentionText = (text) => {
      let newText = text;
      let mentionMatchResult = newText.match(/@([^ ]+) /g)
      if (mentionMatchResult && mentionMatchResult.length > 0) {
        for (let i = 0; i < mentionMatchResult.length; i++) {
          let mentionStr = mentionMatchResult[i];
          let name = mentionStr.replace('@[', '@').replace(']', '')
          newText = newText.replace(mentionStr, name);
        }
      }
      return newText;
    }
    // 解析@
    const parseMention = (text) => {
      const mentionCache = state.mentionCache;
      let mention = new MentionModel();
      if (mentionCache) {
        let mentions = Object.values(mentionCache);
        let all = false;
        if (mentions.length > 0) {
          let mentionUIDS = new Array();
          let mentionMatchResult = text.match(/@([^ ]+) /g)
          if (mentionMatchResult && mentionMatchResult.length > 0) {
            for (let i = 0; i < mentionMatchResult.length; i++) {
              let mentionStr = mentionMatchResult[i];
              let name = mentionStr.trim().replace('@', '')
              let member = mentionCache[name];
              if (member) {
                if (member.uid === -1) { // -1表示@所有人
                  all = true;
                } else {
                  mentionUIDS.push(member.uid)
                }
              }
            }
          }
          if (all) {
            mention.all = true
          } else {
            mention.uids = mentionUIDS
          }
        }
        return mention;
      }
      return undefined
    }

    // 发送消息
    const onFs = async () => {
      if (state.inputValue && state.inputValue.trim() !== "") {
        let formatValue = formatMentionText(state.inputValue);
        let mention = parseMention(formatValue)

        const content = new MessageText(formatValue)
        if (mention) {
          const mn = new Mention()
          mn.all = mention.all
          mn.uids = mention.uids
          content.mention = mn
        }
        if (state.currentReplyMessage) {
          const reply = new Reply()
          reply.messageID = state.currentReplyMessage.messageID
          reply.messageSeq = state.currentReplyMessage.messageSeq
          reply.fromUID = state.currentReplyMessage.fromUID
          const channelInfo = WKSDK.shared().channelManager.getChannelInfo(new Channel(state.currentReplyMessage
            .fromUID, ChannelTypePerson))
          if (channelInfo) {
            reply.fromName = channelInfo.title
          }
          reply.avatar = state.currentReplyMessage.user_extra.avatar
          reply.nickname = state.currentReplyMessage.user_extra.nickname
          reply.content = state.currentReplyMessage.content
          content.reply = reply
        }

        // const channelInfo = WKSDK.shared().channelManager.getChannelInfo(new Channel(state.channelID, state
        //   .channelType))
        // let setting = {}
        // if (channelInfo?.orgData.receipt === 1) {
        //   setting.receiptEnabled = true
        // }

        await WKSDK.shared().chatManager.send(content, new Channel(state.channelID, state.channelType))

        state.inputValue = ''
        state.mentionCache = {}
        state.currentReplyMessage = null
      }
      // const msgContent = new MessageText(state.inputValue)
      // WKSDK.shared().chatManager.send(msgContent, new Channel(state.channelID, state.channelType))
    }

    const getUUID = () => {
      var len = 32;//32长度
      var radix = 16;//16进制
      var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split(''); var uuid = [], i; radix = radix || chars.length; if (len) { for (i = 0; i < len; i++)uuid[i] = chars[0 | Math.random() * radix]; } else { var r; uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'; uuid[14] = '4'; for (i = 0; i < 36; i++) { if (!uuid[i]) { r = 0 | Math.random() * 16; uuid[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r]; } } }
      return uuid.join('');
    }


    // 发送图片
    const afterRead = (params) => {
      let isImage = false
      let file = params.file
      let imageType = file.type
      if (imageType != 'image/jpeg' && imageType != 'image/jpg' && imageType != 'image/png' && imageType !=
        'image/gif') {
        isImage = false
      } else {
        isImage = true
      }
      let isLt2M = file.size / 1024 / 1024 < 2
      if (!isImage) {
        Toast('上传图片只能是 JPG/PNG/JPEG/GIF 格式!');
        return
      }
      if (!isLt2M) {
        Toast('图片最大不能超过2M');
        return
      }
      let formData = new FormData()
      formData.append('file', file)

      const fileName = getUUID();
      const path = `/${state.channelType}/${state.channelID}/${fileName}`
      imrequest({
        url: `/api/v1/file/upload?path=${path}&type=chat`,
        method: 'post',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(async response => {
        console.log("response", response)

        //   if(response.data.path) {
        //       const mediaContent = this.message.content as MediaMessageContent
        //       mediaContent.remoteUrl = response.data.path
        //       this.status = TaskStatus.success
        //       this.update()
        //   }

        // if (response.data.a == 1) {
        //   const msgContent = new MessageImage()
        //   msgContent.url = response.data.c // 图片的下载地址
        //   const imgData = await getImageDimensions(response.data.c)
        //   msgContent.width = imgData.width // 图片宽度
        //   msgContent.height = imgData.height // 图片高度
        //   WKSDK.shared().chatManager.send(msgContent, new Channel(state.channelID, state.channelType))
        //   Toast('上传成功');
        // } else {
        //   Toast(response.data.b);
        // }
      })


      // upload(formData).then(async response => {
      //   if (response.data.a == 1) {
      //     const msgContent = new MessageImage()
      //     msgContent.url = response.data.c // 图片的下载地址
      //     const imgData = await getImageDimensions(response.data.c)
      //     msgContent.width = imgData.width // 图片宽度
      //     msgContent.height = imgData.height // 图片高度
      //     WKSDK.shared().chatManager.send(msgContent, new Channel(state.channelID, state.channelType))
      //     Toast('上传成功');
      //   } else {
      //     Toast(response.data.b);
      //   }
      // })
    }

    // 监听频道信息方法
    const channelInfoFunction = (channelInfo) => {
      console.log('监听频道', channelInfo)
      // WKSDK.shared().channelManager.fetchChannelInfo(new Channel(state.channelID, state.channelType)).then(() => {
      //   state.channelInfo = WKSDK.shared().channelManager.getChannelInfo(new Channel(state.channelID,
      //     state.channelType))
      // })
    }
    const cmdListener = (message) => {
      console.log("conversation收到CMD：", message)
      const cmdContent = message.content
      const param = cmdContent.param;
      if (cmdContent.cmd === "channelUpdate") {
        // 频道信息更新
        WKSDK.shared().channelManager.fetchChannelInfo(
          new Channel(param.channel_id, param.channel_type)
        );
      } else if (cmdContent.cmd === "groupAvatarUpdate") {
        // 频道信息更新
        WKSDK.shared().channelManager.fetchChannelInfo(new Channel(param.group_no, ChannelTypeGroup)).then(() => {
          state.channelInfo = WKSDK.shared().channelManager.getChannelInfo(new Channel(param.group_no, ChannelTypeGroup))
        });
      }
    }


    const checkLogin =  () => {
      return new Promise((resolve, reject) => {
        console.log("获取im登录用户信息1");
        userLogin({
          username: "zksq_" + store.state.username,
          password: md5(store.state.username),
          flag: 1,
          // "avatar":store.state.avatar,
          // "nickname":store.state.nicename,
          // "level":store.state.level?store.state.level:0,
          avatar: store.state.avatar,
          nickname: store.state.nicename,
          level:  0,
        })
          .then((data) => {
            store.state.imtoken = data.data.token;
            store.state.imuid = data.data.uid;
            console.log("imtoken11",store.state.imtoken)
            resolve();
          })
          .catch((error) => {
            Toast(error.msg);
            reject(error);
          });
      });
    }

    // 生命周期：加载后添加事件监听
    onMounted(async () => {
      try {
        Toast.loading({
          duration: 0,
          message: " 加载中...",
          forbidClick: true,
        });
        
        state.channelID = getQueryString("groupId")
        localStorage.setItem("uid", getQueryString("uid"))
        await store.dispatch("getInfo");
        // await store.dispatch("onIm");
        await checkLogin();
        const res =  await isJoinGroup(getQueryString("groupId"),"zksq_" + getQueryString("username"))
        if(res.data.exist){
          state.isJoinGroup = res.data.exist
        }else{
          state.isJoinGroup = false
        }
        console.log("isJoinGroup",res)
        if(store.state.imtoken && store.state.imuid){
          initIm(store.state.imtoken,store.state.imuid);
        }else{
          await store.dispatch("onIm");
        }
        console.log("temp",res)

        setTimeout(()=>{
          getPdData()
        },0)
        
        // 添加频道信息监听
        WKSDK.shared().channelManager.addListener(channelInfoFunction)
        // 监听cmd消息
        WKSDK.shared().chatManager.addCMDListener(cmdListener)
        // 监听订阅者变化
        WKSDK.shared().channelManager.addSubscriberChangeListener((channel) => {
          if (!new Channel(state.channelID, state.channelType).isEqual(channel)) {
            return
          }
          state.subscribers = WKSDK.shared().channelManager.getSubscribes(new Channel(state.channelID, state
            .channelType))
        })

        document.addEventListener('click', handleClickOutside)

        if (state.isJoinGroup) {
          Toast.clear()
        } else {
          Toast("未加入群聊，请先加群")
        }


      } catch (error) {
        Toast.clear()
      }

    })

    // 生命周期：卸载时移除事件监听
    onUnmounted(() => {

      // 移除频道信息监听
      WKSDK.shared().channelManager.removeListener(channelInfoFunction)
      // 取消监听cmd消息
      WKSDK.shared().chatManager.removeCMDListener(cmdListener)

      document.removeEventListener('click', handleClickOutside)
    })
    const onOpen = () => {
      // router.push({ path: '/wukongim/setting' ,query:{channelID:state.channelID,channelType:state.channelType}})
      conversationPopup.value.onOpen()
    }
    // 查找对应用户信息
    const findElementById = (arr, fromUID) => {
      // find方法遍历数组，返回第一个满足条件的元素
      return arr.find(item => item.id === fromUID);
    }
    // 获取要回复的对象信息
    const handleGrandsonData = (value) => {
      console.log('祖宗组件方法被触发，接收的值：', value)
      state.currentReplyMessage = value
      // 这里可以写祖宗组件需要执行的其他逻辑
      if (state.currentReplyMessage.fromUID != store.state.imuid) {
        // 兼容不同浏览器的光标位置获取
        const startPos = inputRef.value.selectionStart
        // 保存输入框原有内容
        const originalValue = state.inputValue;
        // 在光标位置插入@符号
        const newValue = originalValue.substring(0, startPos) + // 光标前的内容
          '@'
        // 更新输入框内容
        state.inputValue = newValue;
        atPosition.value = state.inputValue.lastIndexOf('@')
        const user = findElementById(state.selectedItems, state.currentReplyMessage.fromUID)
        if (user) {
          selectUser(user)
        }
      }
    }

    const applyTeam = async () => {

      try {
        Toast.loading({
          duration: 0,
          message: " 加载中...",
          forbidClick: true,
        });

        if (!store.state.imtoken) {
          await store.dispatch("getInfo");
          await store.dispatch("onIm");
        }

        if (!state.channelID) {
          Toast("没有配置群组id")
          return
        }

        const blackRes = await wkGroupBlacklist({
          groupId: state.channelID,
          plat: "zksq",
          username: store.state.username,
        })

        if(blackRes.data.code != 1){
          Toast(blackRes.data.msg)
          return
        }
        await groupsMembers(state.channelID, {
          members: [store.state.imuid]
        })



        await getConversations()
        getPdData()

        state.isJoinGroup = true
        Toast("加群成功")


      } catch (error) {
        if (error.msg) {
          Toast(error.msg)
        } else {
          Toast(error)
        }


      }



    }


    // 向后代组件提供方法（关键：让孙子组件能拿到这个方法）
    provide('triggerAncestorMethod', handleGrandsonData)
    return {
      conversationPopup,
      listLeft,
      listTop,
      inputRef,
      textareaRef,
      state,
      onClickLeft,
      onFs,
      handleInput,
      handleInputClick,
      selectUser,
      afterRead,
      onOpen,
      onEnter,
      onKeydown,
      store,
      applyTeam
    }
  }
}
</script>

<!-- <style src="../../../styles/van-sticky-nav.css" scoped></style> -->
<style scoped="scoped">
.van-nav-bar {
  background: #090F1A;
  /* background:linear-gradient(#e2e2e2 30%, 40%, #f7f7f7 60%); */
}

.left-nr {
  display: flex;
  justify-content: center;
  align-items: center;
}

.left-nr img {
  width: 60px;
  height: 60px;
}

.conversation-page {
  height: 100vh;
  background-color: #090F1A;
  display: flex;
  flex-direction: column;
}

.title-box {
  display: flex;
  align-items: center;
}

.title-box img {
  width: 70px;
  height: 70px;
  border-radius: 50%;
}

.title-box h3 {
  font-size: 28px;
  color: #333;
  margin-left: 10px;
}

.content {
  flex: 1;
  height: 100%;
}

.foot {
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}

.foot .reply-box {
  display: flex;
  align-items: center;
  background-color: #283138;
  padding: 10px 0;
}

.foot .reply-box .close {
  width: 100px;
  height: 100px;
  border-right: 1px solid #090F1A;
  display: flex;
  align-items: center;
  justify-content: center;
}

.foot .reply-box .info {
  flex: 1;
  width: 100%;
  overflow: hidden;
  padding-left: 20px;
}

.foot .reply-box .info .user {
  display: flex;
  align-items: center;
}

.foot .reply-box .info .user .user-avatar {
  width: 40px;
  height: 40px;
    flex-shrink: 0;
}

.foot .reply-box .info .user h3 {
  color: #fff;
  font-size: 28px;
  margin-left: 10px;
}

.foot .reply-box .info p {
  color: #fff;
  font-size: 28px;
  margin-top: 10px;
}

.foot-gn {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}

.foot-gn img {
  width: 50px;
  margin-top: 10px;
}

.textarea-box {
  position: relative;
  padding: 10px 30px 30px 30px;
  display: flex;
}

.textarea-box .btn {
  width: 100px;
  height: 70px;
  background-color: #12CDB0;
  color: #fff;
  border-radius: 10px;
  font-size: 24px;
  text-align: center;
  line-height: 70px;
  margin-left: 10px;
}

.at-input {
  width: 100%;
  height: 70px;
  font-size: 28px;
  background-color: initial;
  border: 0;
  flex: 1;
  background-color: #283138;
  padding: 0 20px;
  border-radius: 10px;
  line-height: 70px;
  color: #fff;
}

.user-list {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 500px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 100;
  max-height: 80%;
  overflow-y: scroll;
}

.user-item {
  padding: 20px 30px;
  cursor: pointer;
  font-size: 28px;
  display: flex;
  align-items: center;
}

.user-item .user-avatar {
  width: 50px;
  height: 50px;
    flex-shrink: 0;
}

.user-item p {
  font-size: 28px;
  color: #666;
  margin-left: 20px;
    flex-shrink: 0;
}

.user-item:hover {
  background-color: #f3f4f6;
}



.inputTopV {
  display: flex;
  padding: 20px 32px;
  padding-bottom: 20px;
  align-items: center;
  background-color: #090F1A;
  /* padding-bottom: 80px; */
}

.inputTopV div {
  width: 100%;
  border-radius: 12px;
  background-color: red;
  padding-top: 12px;
  padding-bottom: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #283138;
  color: white;
}

.inputTopV div span:nth-of-type(1) {
  color: #cccccc;
  font-size: 28px;
  margin-left: 24px;
}

.inputTopV div span:nth-of-type(2) {
  color: #00d9c5;
  font-size: 28px;
  margin-right: 24px;
}

.at-input::placeholder {
  color: #ccc;
  /* 灰色 */
}
</style>